module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.d95d6f5d.woff";